import React, { Component } from 'react'
import {
    Row,
    Col,
    Input,
    Button,
    PageHeader,
    Table,
    message,
} from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import axios from 'axios'
import qs from 'qs'
import Addmoudel from '../Addmoudel';
import Editmoudel from '../Editmoudel';
import Deletepopup from '../Deletepopup'

export default class Applabel extends Component {

    constructor(props) {
        super(props);

        // 转化日期格式的函数
        function dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        }

        this.columns = [
            {
                title: '应用标签名称',
                dataIndex: 'name',
                render: (_, record) =>
                    this.state.data.length >= 1 ? (
                        <Editmoudel name={record.name} id={record.id} remark={record.remark} address='应用标签' editData={this.editData} />
                    ) : null,
            },
            {
                title: '更新日期',
                dataIndex: 'date',
                render: (_, record) =>
                    this.state.data.length >= 1 ? (
                        dateFormat('YYYY-mm-dd HH:MM', new Date(record.createTime))
                    ) : null,
            },
            {
                title: '操作',
                dataIndex: 'operation',
                width: '100px',
                render: (_, record) =>
                    this.state.data.length >= 1 ? (
                        <Deletepopup address='应用标签' delData={() => this.handleDelete(record.id)}></Deletepopup>
                    ) : null,
            },
        ];
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                onChange: (page) => {
                    this.setState({
                        pagination: { ...this.state.pagination, current: page }
                    }, () => {
                        this.sendRequset()
                    })
                }
            },
            loading: false,
            showForm: false,
            searchValue: '',
            selectedRowKeys: [],
            data: []
        };
    }

    componentDidMount() {
        this.sendRequset()
    }

    sendRequset = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 10,
                page: this.state.pagination.current,
                type: 'APPLICATION_LABEL',
                name: ''
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list,
                pagination: { ...this.state.pagination, total: response.data.page.totalCount }
            })
        })
    }

    handleClick = () => {
        this.setState({ showForm: !this.state.showForm })
    }

    onSearch = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 10,
                page: 1,
                type: 'APPLICATION_LABEL',
                name: this.state.searchValue
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list
            })
        })
    }

    resetSearch = () => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/list',
            data: {
                limit: 10,
                page: 1,
                type: 'APPLICATION_LABEL',
                name: ''
            },
        }).then((response) => {
            this.setState({
                data: response.data.page.list,
                searchValue: ''
            })
        })
    }


    selectRow = (record) => {
        const selectedRowKeys = [...this.state.selectedRowKeys];
        if (selectedRowKeys.indexOf(record.key) >= 0) {
            selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
        } else {
            selectedRowKeys.push(record.key);
        }
        this.setState({ selectedRowKeys });
        return record
    }
    onSelectedRowKeysChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    handleDelete = (id) => {
        const deleteRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        deleteRequest({
            transformRequest: [function (data) {
                data = qs.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/delete',
            data: {
                'type': 'APPLICATION_LABEL',
                'ids': id,
            }
        }).then(() => {
            this.sendRequset()
        }).catch((err) => {
            console.log(err);
        })
    };

    error = () => {
        message.error({
            content: '请选择需要删除的数据',
            style: {
                marginTop: '28vh',
            },
        })
    }

    handleManyDelete = (id) => {
        if (id.length === 0) {
            this.error()
        } else {
            const ids = id.join(',')
            console.log(ids);
            const deleteRequest = axios.create({
                baseURL: 'https://office.yunbiaokj.com:40005',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            })
            deleteRequest({
                transformRequest: [function (data) {
                    data = qs.stringify(data)
                    return data
                }],
                method: 'POST',
                url: '/mxmService/s_setting/delete',
                data: {
                    'type': 'APPLICATION_LABEL',
                    'ids': ids
                }
            }).then(() => {
                this.sendRequset()
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    addData = (value) => {
        // this.setState({
        //     data: [newData, ...this.state.data]
        // })

        const instance = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/json' }
        });
        const param = {
            'id': "",
            'name': value,
            'type': "APPLICATION_LABEL"
        }
        instance({
            transformRequest: [function (data) {
                data = JSON.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/save',
            data: param,
        }).then(() => {
            this.sendRequset()
        }).catch((err) => {
            console.log(err);
        })
    }

    editData = (id, value, describe) => {
        const listRequest = axios.create({
            baseURL: 'https://office.yunbiaokj.com:40005',
            headers: { 'Content-Type': 'application/json' }
        });
        listRequest({
            transformRequest: [function (data) {
                data = JSON.stringify(data)
                return data
            }],
            method: 'POST',
            url: '/mxmService/s_setting/update',
            data: {
                id: id,
                name: value,
                remark: describe,
                type: 'APPLICATION_LABEL',
            },
        }).then(() => {
            this.sendRequset()
        })
    }

    handleChange = (event) => {
        this.setState({
            searchValue: event.target.value
        })
    }

    render() {
        const { showForm, data, pagination, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectedRowKeysChange,
        };
        const columns = this.columns

        return (
            <div className="app-body">
                <PageHeader
                    ghost={false}
                    className="gray-header"
                    title={
                        <div>
                            <Addmoudel btnName='应用标签' addData={this.addData} />&emsp;
                            <Deletepopup delType='btn' address='应用标签' delData={() => this.handleManyDelete(selectedRowKeys)} />
                        </div>
                    }
                    extra={[
                        <Button className="pos-bottom"
                            key="1"
                            onClick={this.handleClick}
                            icon={<DoubleRightOutlined rotate={showForm ? 270 : 90} />}>展开查询</Button>,
                    ]}
                />

                <div style={{ backgroundColor: '#F5F5F5', display: showForm ? 'block' : 'none', borderBottom: '1px solid #dddddd' }} >
                    <Row gutter={16} align={'middle'} style={{ padding: '21px 15px' }}>
                        <Col >
                            <span>模块名称：</span>
                        </Col>
                        <Col span={8} >
                            <Input placeholder="模块名称" onChange={this.handleChange} value={this.state.searchValue} />
                        </Col>
                        <Col span={6}>
                            <Button type="danger" onClick={this.onSearch}>
                                搜索
                            </Button>
                            &emsp;
                            <Button onClick={this.resetSearch} style={{ margin: '0 8px' }}>
                                重置
                            </Button>
                        </Col>
                    </Row>
                </div>
                {/* 带复选框的表格组件 */}
                <div>
                    <Table
                        rowKey='id'
                        rowSelection={rowSelection}
                        pagination={pagination}
                        columns={columns}
                        dataSource={data}
                    />
                </div>
            </div>
        )
    }
}